import { Container, ExternalLink, Mark, Note, TextLink } from '../../components/ui';
import { profile } from '../../data/profile';
import dimensions from '../../data/images.generated.json';

export default function Intro() {
  const { links, portrait } = profile;
  let markIndex = 0;

  return (
    <Container className="pb-8 pt-8 md:pb-12 md:pt-16">
      <h1 className="font-display text-display">{profile.name}</h1>

      <div className="mt-10 grid grid-cols-1 gap-x-8 gap-y-8 md:mt-14 md:grid-cols-12">
        <div className="md:col-span-8">
          <p className="max-w-[34em] font-body text-lead">
            {profile.intro.map((part, i) =>
              part.mark ? (
                <Mark key={i} delay={400 + 500 * markIndex++}>
                  {part.text}
                </Mark>
              ) : (
                <span key={i}>{part.text}</span>
              )
            )}
          </p>

          <ul className="mt-8 flex flex-wrap gap-x-6 gap-y-2 font-display font-medium">
            <li>
              <TextLink href={`mailto:${links.email}`}>Email</TextLink>
            </li>
            <li>
              <ExternalLink href={links.github}>GitHub</ExternalLink>
            </li>
            <li>
              <ExternalLink href={links.linkedin}>LinkedIn</ExternalLink>
            </li>
            <li>
              <ExternalLink href={links.cv}>CV (PDF)</ExternalLink>
            </li>
          </ul>
        </div>

        <aside className="md:col-span-4">
          <img
            src={portrait.src}
            width={dimensions.profile.width}
            height={dimensions.profile.height}
            alt={portrait.alt}
            className="aspect-[4/5] w-36 rounded-frame bg-paper-2 object-cover object-[50%_30%] grayscale"
          />
          <Note className="mt-3">{profile.location}</Note>
        </aside>
      </div>
    </Container>
  );
}
